import _Alert from './Alert';

import './style/index.js';

export type { AlertProps } from './Alert';
export * from './type';

export const Alert = _Alert;
export default Alert;
